<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-row class="mt-n4 mb-n8">
          <v-col>
            <v-switch
              v-model="ombrometer"
              @change="ombrometerToggle()"
              color="indigo darken-3"
              inset
              class="mb-n5 mt-n1"
            >
            <template v-slot:label>
              <span class="text-h6 ml-n2" style="color:#1F245B">Ombrometer</span> 
            </template>
            </v-switch>
          </v-col>
        </v-row>
        <v-row class="my-n8" v-if="ombrometer">
          <v-col>
            <v-checkbox
              v-model="red"
              label="Alert"
              color="red darken-3"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="blue"
              label="Hujan"
              color="#2196F3"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="green"
              label="Tidak Hujan"
              color="green darken-1"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="grey"
              label="Mati"
              color="grey"
              hide-details
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row class="mt-4 mb-n8">
          <v-col>
            <v-switch
              v-model="tinggimukaair"
              @change="tinggimukaairToggle()"
              color="indigo darken-3"
              inset
              class="mb-n5 mt-n1"
            >
            <template v-slot:label>
              <span class="text-h6 ml-n2" style="color:#1F245B">Tinggi Muka Air</span> 
            </template>
            </v-switch>
          </v-col>
        </v-row>
        <v-row class="my-n8" v-if="tinggimukaair">
          <v-col>
            <v-checkbox
              v-model="danger"
              label="SIAGA 1"
              color="red darken-3"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="evacuation"
              label="SIAGA 2"
              color="orange darken-3"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="warning"
              label="SIAGA 3"
              color="yellow accent-4"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="normal"
              label="Normal"
              color="success"
              hide-details
              class="mt-n4 hidden-sm-and-up"
              
            ></v-checkbox>
            <v-checkbox
              v-model="normal"
              label="Normal"
              color="success"
              hide-details
              class="hidden-xs-only"
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-checkbox
              v-model="offline"
              label="Mati"
              color="grey"
              hide-details
              class="mt-n4 hidden-sm-and-up"
            ></v-checkbox>
            <v-checkbox
              v-model="offline"
              label="Mati"
              color="grey"
              hide-details
              class="hidden-xs-only"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
            <l-map
              v-if="showMap"
              :zoom="zoom"
              :center="center"
              :options="mapOptions"
              style="height: 80vH"
              @update:center="centerUpdate"
              @update:zoom="zoomUpdate"
            >
              <l-tile-layer
                :url="url"
              />

              <!-- TMA -->
              <span v-for="item in TMAs" :key="item.id">
              <span v-if="item.condition === 'SIAGA 1' && danger">
                <l-marker 
                  :lat-lng="item.map"
                  :icon="item.icon"
                  :ref="`popup-${item.id}`"
                  >
                  <l-popup>
                    <div>
                      {{item.station}} <br> {{item.location}}
                      <p>
                        Status: {{item.condition}}<br>
                        Tinggi: {{item.ketinggian=='nan'?'NC':item.satuan=='cm'? Math.round(item.ketinggian*100) : item.ketinggian}} {{item.ketinggian=='nan'?'':item.satuan}}<br>
                        Battery: {{item.volt}} Volt <br>
                        Signal: 
                        <span v-if="parseInt(item.signal)>100">
                          <v-icon>mdi-signal-4g</v-icon>
                          <v-icon v-if="parseInt(item.signal)>123" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>115" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>108" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <span v-else>
                          <v-icon v-if="parseInt(item.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>15" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>8" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        Last Update: {{ updateTime(item.time) }}
                      </p>
                    </div>
                  </l-popup>
                </l-marker>
              </span>
              <span v-if="item.condition === 'SIAGA 2' && evacuation">
                <l-marker 
                  :lat-lng="item.map"
                  :icon="item.icon"
                  :ref="`popup-${item.id}`"
                  >
                  <l-popup>
                    <div>
                      {{item.station}} <br> {{item.location}}
                      <p>
                        Status: {{item.condition}}<br>
                        Tinggi: {{item.ketinggian=='nan'?'NC':item.satuan=='cm'? Math.round(item.ketinggian*100) : item.ketinggian}} {{item.ketinggian=='nan'?'':item.satuan}}<br>
                        Battery: {{item.volt}} Volt <br>
                        Signal: 
                        <span v-if="parseInt(item.signal)>100">
                          <v-icon>mdi-signal-4g</v-icon>
                          <v-icon v-if="parseInt(item.signal)>123" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>115" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>108" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <span v-else>
                          <v-icon v-if="parseInt(item.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>15" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>8" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <br>Last Update: {{ updateTime(item.time) }}
                      </p>
                    </div>
                  </l-popup>
                </l-marker>
              </span>
              <span v-if="item.condition === 'SIAGA 3' && warning">
                <l-marker 
                  :lat-lng="item.map"
                  :icon="item.icon"
                  :ref="`popup-${item.id}`"
                  >
                  <l-popup>
                    <div>
                      {{item.station}} <br> {{item.location}}
                      <p>
                        Status: {{item.condition}}<br>
                        Tinggi: {{item.ketinggian=='nan'?'NC':item.satuan=='cm'? Math.round(item.ketinggian*100) : item.ketinggian}} {{item.ketinggian=='nan'?'':item.satuan}}<br>
                        Battery: {{item.volt}} Volt <br>
                        Signal: 
                        <span v-if="parseInt(item.signal)>100">
                          <v-icon>mdi-signal-4g</v-icon>
                          <v-icon v-if="parseInt(item.signal)>123" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>115" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>108" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <span v-else>
                          <v-icon v-if="parseInt(item.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>15" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>8" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <br>Last Update: {{ updateTime(item.time) }}
                      </p>
                    </div>
                  </l-popup>
                </l-marker>
              </span>
              <span v-if="item.condition === 'Normal' && normal">
                <l-marker 
                  :lat-lng="item.map"
                  :icon="item.icon"
                  :ref="`popup-${item.id}`"
                  >
                  <l-popup>
                    <div>
                      {{item.station}} <br> {{item.location}}
                      <p>
                        Status: {{item.condition}}<br>
                        Tinggi: {{item.ketinggian=='nan'?'NC':item.satuan=='cm'? Math.round(item.ketinggian*100) : item.ketinggian}} {{item.ketinggian=='nan'?'':item.satuan}}<br>
                        Battery: {{item.volt}} Volt <br>
                        Signal: 
                        <span v-if="parseInt(item.signal)>100">
                          <v-icon>mdi-signal-4g</v-icon>
                          <v-icon v-if="parseInt(item.signal)>123" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>115" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>108" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <span v-else>
                          <v-icon v-if="parseInt(item.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>15" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>8" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <br>Last Update: {{ updateTime(item.time) }}
                      </p>
                    </div>
                  </l-popup>
                </l-marker>
              </span>
              <span v-if="item.condition === 'Mati' && offline">
                <l-marker 
                  :lat-lng="item.map"
                  :icon="item.icon"
                  :ref="`popup-${item.id}`"
                  >
                  <l-popup>
                    <div>
                      {{item.station}} <br> {{item.location}}
                      <p>
                        Status: {{item.condition}}<br>
                        Tinggi: {{item.ketinggian=='nan'?'NC':item.satuan=='cm'? Math.round(item.ketinggian*100) : item.ketinggian}} {{item.ketinggian=='nan'?'':item.satuan}}<br>
                        Battery: {{item.volt}} Volt <br>
                        Signal: 
                        <span v-if="parseInt(item.signal)>100">
                          <v-icon>mdi-signal-4g</v-icon>
                          <v-icon v-if="parseInt(item.signal)>123" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>115" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>108" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <span v-else>
                          <v-icon v-if="parseInt(item.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>15" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>8" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <br>Last Update: {{ updateTime(item.time) }}
                      </p>
                    </div>
                  </l-popup>
                </l-marker>
              </span>
              </span>

              <!-- Ombrometer -->
              <span v-for="item in devices" :key="item.id">
              <span v-if="item.condition === 'Hujan' && blue">
                <l-marker 
                  :lat-lng="item.map"
                  :icon="item.icon"
                  :ref="`popup-${item.id}`"
                  >
                  <l-popup>
                    <div>
                      {{item.station}} <br> {{item.location}}
                      <p>
                        Status: {{item.condition}}<br>
                        Curah: {{item.curah}} mm<br>
                        Battery: {{item.battery}} Volt <br>
                        Signal: 
                        <span v-if="parseInt(item.signal)>100">
                          <v-icon>mdi-signal-4g</v-icon>
                          <v-icon v-if="parseInt(item.signal)>123" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>115" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>108" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <span v-else>
                          <v-icon v-if="parseInt(item.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>15" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>8" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <br>Last Update: {{ updateTime(item.time) }}
                      </p>
                    </div>
                  </l-popup>
                </l-marker>
              </span>
              <span v-if="item.condition === 'Tidak Hujan' && green">
                <l-marker 
                  :lat-lng="item.map"
                  :icon="item.icon"
                  :ref="`popup-${item.id}`"
                  >
                  <l-popup>
                    <div>
                      {{item.station}} <br> {{item.location}}
                      <p>
                        Status: {{item.condition}}<br>
                        Curah: {{item.curah}} mm<br>
                        Battery: {{item.battery}} Volt<br>
                        Signal: 
                        <span v-if="parseInt(item.signal)>100">
                          <v-icon>mdi-signal-4g</v-icon>
                          <v-icon v-if="parseInt(item.signal)>123" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>115" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>108" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <span v-else>
                          <v-icon v-if="parseInt(item.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>15" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>8" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <br>Last Update: {{ updateTime(item.time) }}
                      </p>
                    </div>
                  </l-popup>
                </l-marker>
              </span>
              <span v-if="red && item.condition!='Hujan' && item.condition!=='Tidak Hujan' && item.condition!=='Mati'">
                <l-marker 
                  :lat-lng="item.map"
                  :icon="item.icon"
                  :ref="`popup-${item.id}`"
                  >
                  <l-popup>
                    <div>
                      {{item.station}} <br> {{item.location}}
                      <p>
                        Status: {{item.condition}}<br>                    
                        Curah: {{item.curah}} mm<br>
                        Battery: {{item.battery}} Volt<br>
                        Signal: 
                        <span v-if="parseInt(item.signal)>100">
                          <v-icon>mdi-signal-4g</v-icon>
                          <v-icon v-if="parseInt(item.signal)>123" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>115" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>108" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <span v-else>
                          <v-icon v-if="parseInt(item.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>15" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>8" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <br>Last Update: {{ updateTime(item.time) }}
                      </p>
                    </div>
                  </l-popup>
                </l-marker>
              </span>
              <span v-if="grey && item.condition==='Mati'">
                <l-marker 
                  :lat-lng="item.map"
                  :icon="item.icon"
                  :ref="`popup-${item.id}`"
                  >
                  <l-popup>
                    <div>
                      {{item.station}} <br> {{item.location}}
                      <p>
                        Status: {{item.condition}}<br>                  
                        Curah: {{item.curah}} mm<br>
                        Battery: {{item.battery}} Volt <br>
                        Signal: 
                        <span v-if="parseInt(item.signal)>100">
                          <v-icon>mdi-signal-4g</v-icon>
                          <v-icon v-if="parseInt(item.signal)>123" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>115" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>108" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        <span v-else>
                          <v-icon v-if="parseInt(item.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>15" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>8" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else color="error">mdi-signal-cellular-outline</v-icon><br>
                        </span>
                        Last Update: {{ updateTime(item.time) }}
                      </p>
                    </div>
                  </l-popup>
                </l-marker>
              </span>
              </span>
            </l-map>
            </v-card>
            <span v-if="role==='Administrator'" >
              <v-row class="text-center">
                <v-col>
                  <v-btn class= "my-2" color="primary" @click="geoJSONButton()">
                    Download KMZ
                  </v-btn>
                </v-col>
              </v-row>
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col 
        cols="12"
        sm="6"
        md="4">
        <h2 style="color:#1F245B">TMA</h2>
        <v-divider class="mb-2"></v-divider>
        <DynamicScroller
          :items="TMAs"
          :min-item-size="170"
          :item-size="170"
          class="scroller"
        >
          <template v-slot="{ item, index, active }">
            <DynamicScrollerItem
              :item="item"
              :active="active"
              :size-dependencies="[
                item.station,
              ]"
              :data-index="index"
            >
              <v-card dark color="accent darken-3" outlined class="ma-2" @click="showDetail(item.id)">
                <v-card-title>
                  <span v-if="item.station.length<=25" class="text-subtitle-1 font-weight-medium">{{ item.station }}</span>
                  <span v-else class="text-body-2">{{ item.station }}</span>
                </v-card-title>
                <v-card-subtitle>{{ item.location }}</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="color:white">
                  <v-row class="text-center">
                    <v-col cols="auto">
                      <v-chip :color="item.condition=='Normal'?'success darken-3':item.condition=='SIAGA 1'?'red darken-4':item.condition=='SIAGA 2'?'orange darken-4':item.condition=='SIAGA 3'?'yellow darken-2':'grey darken-3'">{{ item.condition }}</v-chip>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                      <span class="text-body-1 ma-auto" v-if="item.ketinggian!='nan'"> {{ item.satuan=='cm'?parseFloat(item.ketinggian*100).toFixed(2):parseFloat(item.ketinggian).toFixed(2) }}&nbsp;{{ item.satuan }}</span>
                      <span class="text-body-1 ma-auto" v-else> NC </span>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                      <span class="text-body-2 font-weight-regular float-right">{{ item.volt }}V</span>
                      <v-icon class="float-right" v-if="parseInt(item.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>15" class="float-right" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>8" class="float-right" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else class="float-right" color="error">mdi-signal-cellular-outline</v-icon>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </DynamicScrollerItem>
          </template>
        </DynamicScroller>
        <br>
        <h2 style="color:#1F245B">PCH</h2>
        <v-divider class="mb-2"></v-divider>
        <DynamicScroller
          :items="devices"
          :min-item-size="170"
          :item-size="170"
          class="scroller"
        >
          <template v-slot="{ item, index, active }">
            <DynamicScrollerItem
              :item="item"
              :active="active"
              :size-dependencies="[
                item.station,
              ]"
              :data-index="index"
            >
              <v-card dark color="accent darken-3" outlined class="ma-2"  @click="showDetail(item.id)">
                <v-card-title>
                  <span v-if="item.station.length<=25" class="text-subtitle-1 font-weight-medium">{{ item.station }}</span>
                  <span v-else class="text-body-2">{{ item.station }}</span>
                </v-card-title>
                <v-card-subtitle>{{ item.location }}</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="color:white">
                  <v-row class="text-center">
                    <v-col cols="auto">
                      <v-chip :color="item.condition=='Tidak Hujan'?'success darken-3':(item.condition=='Notif C' || item.condition=='Notif A')?'red darken-4':item.condition=='Hujan'?'primary darken-4':'grey darken-3'">{{ item.condition }}</v-chip>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                      <span class="text-body-1 ma-auto"> {{ parseFloat(item.curah).toFixed(2) }}&nbsp;mm</span>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                      <span class="text-body-2 font-weight-regular float-right">{{ item.battery }}V</span>
                      <v-icon class="float-right" v-if="parseInt(item.signal)>23" color="success">mdi-signal-cellular-3</v-icon> <v-icon v-else-if="parseInt(item.signal)>15" class="float-right" color="yellow accent-4">mdi-signal-cellular-2</v-icon> <v-icon v-else-if="parseInt(item.signal)>8" class="float-right" color="warning">mdi-signal-cellular-1</v-icon> <v-icon v-else class="float-right" color="error">mdi-signal-cellular-outline</v-icon>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </DynamicScrollerItem>
          </template>
        </DynamicScroller>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { db }from "../firebase/db.js"
// import moment from 'moment'
import { latLng, icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup,  } from "vue2-leaflet";

import { Icon } from 'leaflet';

import GeoJSON from 'geojson'
import tokml from "geojson-to-kml";
import JSZip from 'jszip'
import { saveAs } from 'file-saver';
import moment from 'moment'


// import axios from "axios"

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


export default {
  name: "Example",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  data() {
    return {
      red:true,
      green:true,
      blue:true,
      grey:true,
      warning:true,
      evacuation:true,
      danger:true,
      normal:true,
      offline:true,
      role: null,
      zoom: 9,
      center: latLng(-6.87, 107.579),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      Rlatlng: latLng(-6.87, 107.579),
      latlng: [],
      devices:[],
      infoTime:[],
      mapOptions: {
        zoomSnap: 0.5
      },
      periodic:[],
      conditions:[],
      showMap: true,
      closeButton: false,
      geoData:[],
      recapData:[],
      TMAs:[],
      Bicon: icon({
        iconRetinaUrl: require('@/assets/Map/BSphere.png'),
        iconUrl: require('@/assets/Map/BSphere.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      Ricon: icon({
        iconRetinaUrl: require('@/assets/Map/RSphere.png'),
        iconUrl: require('@/assets/Map/RSphere.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      Gicon: icon({
        iconRetinaUrl: require('@/assets/Map/GSphere.png'),
        iconUrl: require('@/assets/Map/GSphere.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      Yicon: icon({
        iconRetinaUrl: require('@/assets/Map/YSphere.png'),
        iconUrl: require('@/assets/Map/YSphere.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      redTMA: icon({
        iconRetinaUrl: require('@/assets/Map/resized/redTMA.png'),
        iconUrl: require('@/assets/Map/resized/redTMA.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      greenTMA: icon({
        iconRetinaUrl: require('@/assets/Map/resized/greenTMA.png'),
        iconUrl: require('@/assets/Map/resized/greenTMA.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      yellowTMA: icon({
        iconRetinaUrl: require('@/assets/Map/resized/yellowTMA.png'),
        iconUrl: require('@/assets/Map/resized/yellowTMA.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      orangeTMA: icon({
        iconRetinaUrl: require('@/assets/Map/resized/orangeTMA.png'),
        iconUrl: require('@/assets/Map/resized/orangeTMA.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      greyTMA: icon({
        iconRetinaUrl: require('@/assets/Map/resized/greyTMA.png'),
        iconUrl: require('@/assets/Map/resized/greyTMA.png'),
        iconAnchor: [9,9],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),

      BiconBBWS: icon({
        iconRetinaUrl: require('@/assets/Map/BSphereBBWS.png'),
        iconUrl: require('@/assets/Map/BSphereBBWS.png'),
        iconAnchor: [10,10],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      RiconBBWS: icon({
        iconRetinaUrl: require('@/assets/Map/RSphereBBWS.png'),
        iconUrl: require('@/assets/Map/RSphereBBWS.png'),
        iconAnchor: [10,10],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      GiconBBWS: icon({
        iconRetinaUrl: require('@/assets/Map/GSphereBBWS.png'),
        iconUrl: require('@/assets/Map/GSphereBBWS.png'),
        iconAnchor: [10,10],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      YiconBBWS: icon({
        iconRetinaUrl: require('@/assets/Map/YSphereBBWS.png'),
        iconUrl: require('@/assets/Map/YSphereBBWS.png'),
        iconAnchor: [10,10],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),

      redTMABBWS: icon({
        iconRetinaUrl: require('@/assets/Map/redTMABBWS.png'),
        iconUrl: require('@/assets/Map/redTMABBWS.png'),
        iconAnchor: [10,10],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      greenTMABBWS: icon({
        iconRetinaUrl: require('@/assets/Map/greenTMABBWS.png'),
        iconUrl: require('@/assets/Map/greenTMABBWS.png'),
        iconAnchor: [10,10],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      yellowTMABBWS: icon({
        iconRetinaUrl: require('@/assets/Map/yellowTMABBWS.png'),
        iconUrl: require('@/assets/Map/yellowTMABBWS.png'),
        iconAnchor: [10,10],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      orangeTMABBWS: icon({
        iconRetinaUrl: require('@/assets/Map/orangeTMABBWS.png'),
        iconUrl: require('@/assets/Map/orangeTMABBWS.png'),
        iconAnchor: [10,10],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),
      greyTMABBWS: icon({
        iconRetinaUrl: require('@/assets/Map/greyTMABBWS.png'),
        iconUrl: require('@/assets/Map/greyTMABBWS.png'),
        iconAnchor: [10,10],
        popupAnchor: [0,0],
        // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        // shadowAnchor: [14,38],
      }),

      ombrometer:true,
      tinggimukaair:true,
    };
  },
  async mounted () {
    const date=new Date();
    this.offset=date.getTimezoneOffset()/(-60)
    let loader = this.$loading.show()
    this.role = localStorage.getItem("role")
    let setByLocation=false
    console.log(this.role)
    if (this.role== null) {
      loader.hide()
      this.$router.push('login')
    }
    if (localStorage.getItem("role")=='Petugas') {
      let device = localStorage.getItem('device')
      this.$router.push(`/MapPetugas-id=${device}&device=${localStorage.getItem('jenis')}`)
    }
    await db.collection('roleSetting').doc(this.role).get().then((doc)=> {
      setByLocation=doc.data().location
    }).catch(()=> {
      loader.hide()
    })
    var TMARef = db.collection('radar').orderBy('location','desc')
    var deviceRef= db.collection('device')
    var periodicRef = db.collection('periodic')
    var recapRef = db.collection('report')
    if (setByLocation) {
      deviceRef= db.collection('device').where('location','==',localStorage.getItem('location'))
      periodicRef= db.collection('periodic').where('location','==',localStorage.getItem('location'))
      TMARef = db.collection('radar').where('location','==',localStorage.getItem('location'))
    }
    TMARef.onSnapshot(async (collectionSnapshot) => {
      this.TMAs=[]
      collectionSnapshot.forEach((doc)=> {
        if ((doc.data().location=='MARNOV') && (localStorage.getItem('location')!='MARNOV') || (doc.data().location==undefined)){
          return
        }
        // console.log(`TMA ${doc.data().station}_${Date.now()/1000 - parseInt(doc.data().timestamp)}_${parseInt(doc.data().periodic)*120}_${parseInt(doc.data().periodic)}`)
        // console.log(doc.data().ketinggian)
        if (doc.id.includes('BBWS')||doc.id.includes('SDATELEMETRY')|| doc.id.includes('ews') || doc.id.includes('monita')) {
          this.TMAs.push({
            time:  parseInt(doc.data().timestamp),
            station: doc.data().station,
            expire: doc.data().expire,
            location: doc.data().location,
            volt: doc.data().volt,
            ketinggian: doc.data().ketinggian,
            condition: (Date.now()/1000 - parseInt(doc.data().timestamp) > parseInt(doc.data().periodic)*120)? 'Mati' : doc.data().bahaya=="1" ? 'SIAGA 1' : doc.data().waspada=="1" ? 'SIAGA 3' : doc.data().evakuasi=="1" ? 'SIAGA 2' : 'Normal',
            icon: (Date.now()/1000 - parseInt(doc.data().timestamp) > parseInt(doc.data().periodic)*120)? this.greyTMABBWS : doc.data().bahaya=="1" ? this.redTMABBWS : doc.data().waspada=="1" ? this.yellowTMABBWS : doc.data().evakuasi=="1" ? this.orangeTMABBWS : this.greenTMABBWS,
            map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)),
            satuan: doc.data().satuan,
            signal:doc.data().signal,
            id:doc.id
          })
        } else {
          this.TMAs.push({
            time:  parseInt(doc.data().timestamp),
            station: doc.data().station,
            expire: doc.data().expire,
            location: doc.data().location,
            volt: doc.data().volt,
            ketinggian: doc.data().ketinggian,
            condition: (Date.now()/1000 - parseInt(doc.data().timestamp) > parseInt(doc.data().periodic)*120)? 'Mati' : doc.data().bahaya=="1" ? 'SIAGA 1' : doc.data().waspada=="1" ? 'SIAGA 3' : doc.data().evakuasi=="1" ? 'SIAGA 2' : 'Normal',
            icon: (Date.now()/1000 - parseInt(doc.data().timestamp) > parseInt(doc.data().periodic)*120)? this.greyTMA : doc.data().bahaya=="1" ? this.redTMA : doc.data().waspada=="1" ? this.yellowTMA : doc.data().evakuasi=="1" ? this.orangeTMA : this.greenTMA,
            map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)),
            satuan: doc.data().satuan,
            signal:doc.data().signal,
            id:doc.id
          })
        }
      })
      this.TMAs.sort((a,b)=> {
        if (a.condition == 'SIAGA 1')  {
          return -1
        } else if (a.condition == 'SIAGA 2' && b.condition!='SIAGA 1') {
          return -1
        } else if (a.condition == 'SIAGA 3' && b.condition!='SIAGA 2' && b.condition!='SIAGA 1') {
          return -1
        } else if (a.condition == 'Normal' && b.condition!='SIAGA 3' && b.condition!='SIAGA 2' && b.condition!='SIAGA 1') {
          return -1
        }
        return 1
      })
    })
    deviceRef.onSnapshot((collectionSnapshot) => {
      let icon=null
      let iconColor=null
      let time=Date.now()/1000  
      periodicRef.onSnapshot((collections) => {
        this.periodic=[]
        collections.forEach((doc) => {
          this.periodic.push({id:doc.id,...doc.data()})
        })
      })
      recapRef.onSnapshot((collections) => {
        this.recapData=[]
        collections.forEach((doc)=> {
          this.recapData.push({id:doc.id, ...doc.data()})
        })
      })   
      db.collection('setting').onSnapshot((collections) => {
        this.infoTime=[]
        collections.forEach((doc) => {
          this.infoTime.push({id:doc.id, infotime:doc.data().infotime, infotime32:doc.data().infotime32, chip:doc.data().chip})
        })
        let index=0;
        let indexP=0;
        let indexR=0;
        let i=0
        this.conditions=[]
        this.devices=[]
        this.geoData=[]
        collectionSnapshot.forEach((doc) => {
          if (doc.data().location=='MARNOV') {
            if (localStorage.getItem('location')=='MARNOV') {
              this.conditions.push(doc.data().condition)
              index = this.infoTime.findIndex(x => x.id === doc.id);
              indexP = this.periodic.findIndex(x => x.id === doc.id);
              indexR = this.recapData.findIndex(x => x.id === doc.id);
              if (index!=-1) {
                if (this.infoTime[index].chip=="ESP32") {
                  this.infoTime[index].infotime=this.infoTime[index].infotime32
                }
                if (time-parseInt(doc.data().time)>(120*parseInt(this.infoTime[index].infotime))) {
                  // console.log(`Ombro ${doc.data().station}_${time - parseInt(doc.data().time)}_${120*parseInt(this.infoTime[index].infotime)}_${this.infoTime[index].infotime}`)
                  icon=doc.id.includes('BBWS')||doc.id.includes('SDATELEMETRY')|| doc.id.includes('ews')?this.YiconBBWS:this.Yicon
                  iconColor='Yellow'
                  this.conditions[i]= 'Mati'
                } else {
                  if (doc.data().condition == 'Hujan') {
                    icon=doc.id.includes('BBWS')||doc.id.includes('SDATELEMETRY')|| doc.id.includes('ews')?this.BiconBBWS:this.Bicon
                    iconColor='Blue'
                  } else if (doc.data().condition == 'Tidak Hujan') {
                    icon=doc.id.includes('BBWS')||doc.id.includes('SDATELEMETRY')|| doc.id.includes('ews')?this.GiconBBWS:this.Gicon
                    iconColor='Green'
                  } else {
                    icon=doc.id.includes('BBWS')||doc.id.includes('SDATELEMETRY')|| doc.id.includes('ews')?this.RiconBBWS:this.Ricon
                    iconColor='Red'
                  }
                }
                if (indexP!=-1) {
                  this.geoData.push({name: doc.data().station?doc.data().station:"-", lat: doc.data().latitude, lng: doc.data().longitude, map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)), location:doc.data().location?doc.data().location:"-", macAddress:doc.data().macAddress?doc.data().macAddress:doc.id, phoneNumber: doc.data().phoneNumber?doc.data().phoneNumber:"-", Icon:iconColor})
                  if (indexR!=-1) {
                    this.devices.push({time: parseInt(doc.data().time),id:doc.id,icon: icon, station: doc.data().station, map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)), location:doc.data().location, condition:this.conditions[i], curah: this.periodic[indexP].rainvol, battery: this.periodic[indexP].voltage, masaAktif:this.recapData[indexR].expire, signal:this.periodic[indexP].signal })                
                  } else {
                    this.devices.push({time: parseInt(doc.data().time),id:doc.id,icon: icon, station: doc.data().station, map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)), location:doc.data().location, condition:this.conditions[i], curah: this.periodic[indexP].rainvol, battery: this.periodic[indexP].voltage, masaAktif:'Not Available', signal:this.periodic[indexP].signal})                
                  }
                } else {
                  this.geoData.push({name: doc.data().station?doc.data().station:"-", lat: doc.data().latitude, lng: doc.data().longitude, map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)), location:doc.data().location?doc.data().location:"-", macAddress:doc.data().macAddress?doc.data().macAddress:doc.id, phoneNumber: doc.data().phoneNumber?doc.data().phoneNumber:"-", Icon:iconColor})
                  if (indexR!=-1) {
                    this.devices.push({time: parseInt(doc.data().time),id:doc.id,icon: icon, station: doc.data().station, map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)), location:doc.data().location, condition:this.conditions[i], curah: 'N/A', battery: 'N/A', masaAktif:this.recapData[indexR].expire})
                  } else {
                    this.devices.push({time: parseInt(doc.data().time),id:doc.id,icon: icon, station: doc.data().station, map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)), location:doc.data().location, condition:this.conditions[i], curah: 'N/A', battery: 'N/A', masaAktif:'Not Available'})
                  }
                }
              }
              i++;
            }
          } else {
            this.conditions.push(doc.data().condition)
            index = this.infoTime.findIndex(x => x.id === doc.id);
            indexP = this.periodic.findIndex(x => x.id === doc.id)
            indexR = this.recapData.findIndex(x => x.id === doc.id);
            if (index!=-1) {
              if (this.infoTime[index].chip=="ESP32") {
                this.infoTime[index].infotime=this.infoTime[index].infotime32
              }
              if (time-parseInt(doc.data().time)>(120*parseInt(this.infoTime[index].infotime))) {
                // console.log(`Ombro ${doc.data().station}_${time - parseInt(doc.data().time)}_${120*parseInt(this.infoTime[index].infotime)}_${this.infoTime[index].infotime}`)
                icon=doc.id.includes('BBWS')||doc.id.includes('SDATELEMETRY')|| doc.id.includes('ews')?this.YiconBBWS:this.Yicon
                iconColor='Yellow'
                this.conditions[i]= 'Mati'
              } else {
                if (doc.data().condition == 'Hujan') {
                  icon=doc.id.includes('BBWS')||doc.id.includes('SDATELEMETRY')|| doc.id.includes('ews')?this.BiconBBWS:this.Bicon
                  iconColor='Blue'
                } else if (doc.data().condition == 'Tidak Hujan') {
                  icon=doc.id.includes('BBWS')||doc.id.includes('SDATELEMETRY')|| doc.id.includes('ews')?this.GiconBBWS:this.Gicon
                  iconColor='Green'
                } else {
                  icon=doc.id.includes('BBWS')||doc.id.includes('SDATELEMETRY')|| doc.id.includes('ews')?this.RiconBBWS:this.Ricon
                  iconColor='Red'
                }
              }
              if (indexP!=-1) {
                this.geoData.push({name: doc.data().station?doc.data().station:"-", lat: doc.data().latitude, lng: doc.data().longitude, map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)), location:doc.data().location?doc.data().location:"-", macAddress:doc.data().macAddress?doc.data().macAddress:doc.id, phoneNumber: doc.data().phoneNumber?doc.data().phoneNumber:"-", Icon:iconColor})
                if (indexR!=-1) {
                  this.devices.push({time: parseInt(doc.data().time),id:doc.id,icon: icon, station: doc.data().station, map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)), location:doc.data().location, condition:this.conditions[i], curah: this.periodic[indexP].rainvol, battery: this.periodic[indexP].voltage, masaAktif:this.recapData[indexR].expire, signal:this.periodic[indexP].signal})                
                } else {
                  this.devices.push({time: parseInt(doc.data().time),id:doc.id,icon: icon, station: doc.data().station, map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)), location:doc.data().location, condition:this.conditions[i], curah: this.periodic[indexP].rainvol, battery: this.periodic[indexP].voltage, masaAktif:'Not Available', signal:this.periodic[indexP].signal})                
                }
              } else {
                this.geoData.push({name: doc.data().station?doc.data().station:"-", lat: doc.data().latitude, lng: doc.data().longitude, map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)), location:doc.data().location?doc.data().location:"-", macAddress:doc.data().macAddress?doc.data().macAddress:doc.id, phoneNumber: doc.data().phoneNumber?doc.data().phoneNumber:"-", Icon:iconColor})
                if (indexR!=-1) {
                  this.devices.push({time: parseInt(doc.data().time),id:doc.id,icon: icon, station: doc.data().station, map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)), location:doc.data().location, condition:this.conditions[i], curah: 'N/A', battery: 'N/A', masaAktif:this.recapData[indexR].expire})
                } else {
                  this.devices.push({time: parseInt(doc.data().time),id:doc.id,icon: icon, station: doc.data().station, map:latLng(parseFloat(doc.data().latitude),parseFloat(doc.data().longitude)), location:doc.data().location, condition:this.conditions[i], curah: 'N/A', battery: 'N/A', masaAktif:'Not Available'})
                }
              }
            }
            i++;
          } 
        });
        this.devices.sort((a,b)=> {
          if (a.condition == 'Notif A' || a.condition == 'Notif C')  {
            return -1
          } else if (a.condition == 'Hujan' && (b.condition != 'Notif A' || b.condition != 'Notif C')) {
            return -1
          } else if (a.condition == 'Tidak Hujan' && (b.condition != 'Notif A' || b.condition != 'Notif C') && b.condition!='Hujan') {
            return -1
          } 
          return 1
        })
        loader.hide()
      })
    })
   
  },
  methods: {
    updateTime (time) {
      return moment.unix(time).utcOffset(this.offset).format("HH:mm, DD MMM YYYY")
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    closeButtons () {
      console.log("HELLO")
    },
    showDetail(id) {
      this.$nextTick(() => {
        this.$refs[`popup-${id}`][0].mapObject.openPopup()
      })
    },
    ombrometerToggle() {
      if (this.ombrometer) {
        this.red=true
        this.blue=true
        this.green=true
        this.grey=true
      } else {
        this.red=false
        this.blue=false
        this.green=false
        this.grey=false
      }
    },
    tinggimukaairToggle() {
      if (this.tinggimukaair) {
        this.danger=true
        this.evacuation=true
        this.warning=true
        this.normal=true
        this.offline=true
      } else {
        this.danger=false
        this.evacuation=false
        this.warning=false
        this.normal=false
        this.offline=false
      }
    },
    resolveIccid (data, phoneBook) {
      if (data && data.iccid) return data.iccid
      const phone = data && data.phoneNumber != null ? String(data.phoneNumber) : ''
      if (!phone) return 'N/A'
      if (phone.startsWith('896')) return phone
      const match = (phoneBook || []).find((entry) => entry.ICCID === phone || entry.MSISDN === phone)
      return (match && match.ICCID) ? match.ICCID : 'N/A'
    },
    includeKmzDevice (data) {
      if (!data) return false
      if (data.location === 'MARNOV') return false
      const lat = parseFloat(data.latitude)
      const lng = parseFloat(data.longitude)
      return Number.isFinite(lat) && Number.isFinite(lng)
    },
    async geoJSONButton () {
      const loader = this.$loading.show()
      try {
        let setByLocation = false
        await db.collection('roleSetting').doc(this.role).get().then((doc) => {
          setByLocation = doc.data().location
        }).catch(() => {})

        let phoneBook = []
        await db.collection('setting').doc('phoneNumber').get().then((doc) => {
          phoneBook = (doc.data() && doc.data().phoneNumber) || []
        }).catch(() => {})

        let deviceRef = db.collection('device')
        let radarRef = db.collection('radar')
        if (setByLocation) {
          deviceRef = deviceRef.where('location', '==', localStorage.getItem('location'))
          radarRef = radarRef.where('location', '==', localStorage.getItem('location'))
        }

        const [deviceSnap, radarSnap] = await Promise.all([deviceRef.get(), radarRef.get()])
        const points = []

        deviceSnap.forEach((doc) => {
          const data = doc.data()
          if (!this.includeKmzDevice(data)) return
          points.push({
            name: data.station || '-',
            lat: parseFloat(data.latitude),
            lng: parseFloat(data.longitude),
            location: data.location || '-',
            macAddress: data.macAddress || doc.id,
            ICCID: this.resolveIccid(data, phoneBook),
            jenis: 'PCH',
          })
        })
        radarSnap.forEach((doc) => {
          const data = doc.data()
          if (!this.includeKmzDevice(data)) return
          points.push({
            name: data.station || '-',
            lat: parseFloat(data.latitude),
            lng: parseFloat(data.longitude),
            location: data.location || '-',
            macAddress: doc.id,
            ICCID: this.resolveIccid(data, phoneBook),
            jenis: 'TMA',
          })
        })

        const zip = new JSZip()
        zip.file('devices.kml', tokml(GeoJSON.parse(points, { Point: ['lat', 'lng'] })))
        const content = await zip.generateAsync({ type: 'blob' })
        saveAs(content, 'devices.kmz')
      } catch (err) {
        console.log(err)
      } finally {
        loader.hide()
      }
    },
    // async getEWSDevices() {
    //   let data=[]
    //   await axios.get('https://us-central1-rainmonitor-b0968.cloudfunctions.net/ewsConnector').then(async (res) => {
    //     data=res.data
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
    //   return data
    // }
  }
};
</script>

<style lang="scss">
  .vue2leaflet-map {
    z-index: 1;
  }
  .scroller {
    height: 40vH;
  }
</style>
